export default __webpack_public_path__ + "static/under-water-e2614977d8bda0aa90f6a9c33d20e433.png";